import { render } from "./ResendEventsForm.vue?vue&type=template&id=fdc164ac"
import script from "./ResendEventsForm.vue?vue&type=script&lang=js"
export * from "./ResendEventsForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__